export enum TriggerExpressionOperators {
  GREATER = '>',
  LESS = '<',
  EQUAL = '=',
  NOT_EQUAL = '!='
}